var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemplateText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 42,
    viewBox: "0 0 46 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.625L0 22.75 6.708 26.25 11.5 23.75M6.708 26.25L6.708 20.125M22.042 13.125L15.333 16.625 22.042 20.125 28.75 16.625z",
    transform: "translate(8.625 7.875)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.333 16.625L15.333 22.75 22.042 26.25 28.75 22.75 28.75 16.625M22.042 20.125L22.042 26.25M14.375 0L7.667 3.5 14.375 7 21.083 3.5z",
    transform: "translate(8.625 7.875)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.667 3.5L7.667 9.625 14.375 13.125 21.083 9.625 21.083 3.5M14.375 7L14.375 13.125M11.5 15.625L6.708 13.125 0 16.625 6.708 20.125 10.542 18.125",
    transform: "translate(8.625 7.875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateText);
export default __webpack_public_path__ + "static/media/template_text.6a3bd56d0ea786b6c353f2a3a508b057.svg";
export { ForwardRef as ReactComponent };